export default __webpack_public_path__ + "static/media/Republic2.62156e5b.png";